import clsx from 'clsx';
import { PaletteUtils } from '@shared/utils';

interface InputPreviewProps {
  important?: boolean;
  className?: string;
  caption: string;
  value: string;
}

export const InputPreview = (props: InputPreviewProps) => {
  return (
    <div className={clsx('mb-[20px]', props.className)}>
      <div className={clsx('text-lg  tracking-[-0.1px] mb-[5px]', PaletteUtils.isBordierPalette ? 'text-[#4d3b2c]/60' : 'font-bold text-[#aaaab2]')}>
        {props.caption}
      </div>
      <div
        className={clsx('uppercase', PaletteUtils.isBordierPalette ? '' : 'text-[#4c4c52] text-lg tracking-[0.3px] overflow-hidden text-ellipsis')}
      >
        {props.value}
      </div>
    </div>
  );
};
